<template>
  <div>
    <!--头部-->
    <div class="title-header">
      <div class="title-header-font">关于我们</div>
    </div>
    <!--面包屑-->
    <CurrentLocal :titles="titles"></CurrentLocal>
    <!--Tab页面-->
    <div style="width: 1200px; margin: 10px auto">
      <el-tabs tab-position="left" style="margin-top: 10px; box-shadow: 0 1px 4px rgba(0,21,41,.1);">
        <!--公司简介-->
        <el-tab-pane v-for="(item, i) in companyMsg" :label="item['company_info_name']" :key="i">
          <div style="min-height: 600px" class="company_info">
            <div v-html="item['company_info_desc']"></div>
          </div>
        </el-tab-pane>
        <!--联系我们，循环遍历显示-->
        <el-tab-pane v-for="(item, i) in contactMsg" :label="item['contact_info_name']" :key="i + companyMsg.length">
          <div style="min-height: 600px" class="company_info">
            <div v-html="item['contact_info_desc']"></div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>

  </div>
</template>

<script>
import CurrentLocal from '@/components/CurrentLocal/CurrentLocal'
import { company, contact } from '@/api/about'

export default {
  name: 'about',
  components: { CurrentLocal },
  data () {
    return {
      companyMsg: [],
      contactMsg: [],
      titles: [{ path: '/', name: '首页' },
        { path: '/about', name: '关于我们' }]
    }
  },
  created () {
    this.getCompanyMsg()
    this.getContactMsg()
  },
  methods: {
    getCompanyMsg () {
      company().then(res => {
        this.companyMsg = res.body
      })
    },
    getContactMsg () {
      contact().then(res => {
        this.contactMsg = res.body
      })
    }
  }
}
</script>

<style lang="scss">
  .company_info {
    font-size: 18px;
    letter-spacing: 1.2px;
    color: #71777c;
    font-weight: 500;

    img {
      max-width: 1000px !important;
      margin: 10px;
    }
  }

  /*  .img_float {

  }*/
  /*表格*/
  .company_info table {
    width: 90%;
    font-size: 18px;
    color: #71777c;
    display: table;
    -webkit-border-horizontal-spacing: 0;
    -webkit-border-vertical-spacing: 0;
    border-top-width: 0;
    border-right-width: 0;
    border-bottom-width: 0;
    border-left-width: 0;
    table-layout: fixed;
    border-collapse: separate;
  }

  .company_info table tr {
    display: table-row;
    vertical-align: inherit;
    border-color: inherit;
    transition: background-color .25s ease;
    border-bottom: 1px solid #ebeef5;
  }

  .company_info table tr:hover {
    background-color: #ebeef5;
  }

  .company_info table td {
    border-bottom: 1px solid #ebeef5;
    padding: 16px 0;
    min-width: 0;
    box-sizing: border-box;
    text-overflow: ellipsis;
    vertical-align: middle;
    position: relative;
    text-align: center;
    display: table-cell;
    overflow: hidden;
    white-space: normal;
    word-break: break-all;
    line-height: 23px;
  }

  .company_info table thead {
    line-height: 50px;
    background-color: #fafafa;
  }

  .el-tabs__item {
    font-size: 18px;
    height: 50px;
    line-height: 60px;
    padding: 0 60px 0 20px;
    letter-spacing: 3px;
    font-weight: 100;
  }
</style>
